<template>
  <div class="signout position-relative">
    <div class="d-flex flex-column mt-3 mb-3 ml-4 mr-4">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-row align-items-center mb-4">
          <Logo/>
          <p class="modal-title ml-3 mr-1">Are you sure you want to permanently delete your account?</p>
        </div>
      </div>
      <div class="d-flex justify-content-around">
        <button class="secondary" width="auto" v-on:click="onCancel">Cancel</button>
        <button class="primary" width="auto" v-on:click="onConfirm">Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
import { spinnakerApi } from '../js/SpinnakerApi.js'
import Logo from '../components/Logo.vue'

export default {
  components: {
    Logo
  },
  name: 'DeleteAccount',
  methods: {
    onCancel () {
      this.$modal.hide('delete-account-modal')
    },
    async onConfirm () {
      this.$store.commit('showLoading')

      try {
        await spinnakerApi.deleteAccount()
        await spinnakerApi.switchToCasualUser()
      } catch (err) {
        console.error(`deleteAccount failed: ${err}`)
      }
      this.cleanUp()
    },
    cleanUp () {
      this.$store.commit('hideLoading')
      this.$store.commit('isRegisteredUser', false)
      this.$modal.hide('delete-account-modal')
    }
  }
}
</script>

<style scoped></style>
